import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import 'app-ui/style.css';
import 'app-ui/theme-light.css';
import 'app-ui/theme-dark.css';
import '~/index.css';

import { assertIsDefinedOrThrow } from 'app-shared/utils';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/app/components/App';
import { initializeErrorReporting } from '@/error-reporting/utils/initializeErrorReporting';
import { activateLocale } from '@/localization/utils/activateLocale';
import { detectInitialLocaleFromBrowser } from '@/localization/utils/detectInitialLocaleFromBrowser';

const bootstrap = async () => {
  initializeErrorReporting();

  await activateLocale(detectInitialLocaleFromBrowser());

  const rootElement = document.getElementById('root');
  assertIsDefinedOrThrow(rootElement, new Error('Missing #root element'));

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
};

void bootstrap();
